export default __webpack_public_path__ + "static/media/gimme-yo-money.554f2f05.webp";